export interface EmailTypeDetectionConfig {
  description: string
  aiAssistantInstructions: string
}

export enum EmailTypeKind {
  REPLY = 'reply',
  NEW = 'new',
}

export type EmailAction = 'generateReply' | 'pushToDraft' | 'doNotReply'

interface BaseEmailType {
  id: string
  name: string
  isActive: boolean
  detectionConfig: EmailTypeDetectionConfig
  systemEmailTypeId?: string
  metadata: { [key: string]: any }
}

interface ReplyEmailType extends BaseEmailType {
  kind: EmailTypeKind.REPLY
  roleIds: string[]
  accountEmailAction: EmailAction
  userEmailAction?: EmailAction
  effectiveEmailAction: EmailAction
}

interface NewEmailType extends BaseEmailType {
  kind: EmailTypeKind.NEW
}

export type EmailType = ReplyEmailType | NewEmailType
